import React, { useState, useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';
import useNetworkStatus from '../../hooks/useNetworkStatus';

const NetworkStatus = ({ showInLanding = false }) => {
  // ✅ FIXED: Always call hooks at the top level
  const { isOnline, wasOffline } = useNetworkStatus();
  const [showOfflineAlert, setShowOfflineAlert] = useState(false);
  const [showOnlineAlert, setShowOnlineAlert] = useState(false);
  
  useEffect(() => {
    // Only show in landing pages if explicitly enabled
    if (!showInLanding) return;
    
    if (!isOnline) {
      setShowOfflineAlert(true);
      setShowOnlineAlert(false);
    } else if (wasOffline) {
      setShowOnlineAlert(true);
      setShowOfflineAlert(false);
      
      // Auto hide after 3 seconds
      setTimeout(() => {
        setShowOnlineAlert(false);
      }, 3000);
    }
  }, [isOnline, wasOffline, showInLanding]);
  
  // Don't render anything if not enabled for landing pages
  if (!showInLanding) return null;
  
  return (
    <>
      <Snackbar 
        open={showOfflineAlert} 
        autoHideDuration={6000} 
        onClose={() => setShowOfflineAlert(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="warning" variant="filled">
          You are offline. POSlah is running in offline mode.
        </Alert>
      </Snackbar>
      
      <Snackbar 
        open={showOnlineAlert} 
        autoHideDuration={3000} 
        onClose={() => setShowOnlineAlert(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="success" variant="filled">
          🎉 Back online! Syncing your data...
        </Alert>
      </Snackbar>
    </>
  );
};

export default NetworkStatus;